import { Children, cloneElement, Fragment } from 'react';
import StyleAuxiliary from '../../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import PropTypes from 'prop-types';
import FieldWrapper from '../../../../../components/Form/FieldWrapper';
import useFormInput from '../../../../../utils/hooks/useFormInput';

const RadioSet = ({ label, labelPosition, ...props }) => {
	const {
		meta,
		field: { onChange: onChangeValue } = {},
		additionalProps,
	} = useFormInput(props);

	const onChange = e => {
		if (props.changeHandler) {
			props.changeHandler(e, false);
		}
		if (onChangeValue) {
			onChangeValue(e);
		}
	};

	const children = Children.map(props.children, child => {
		const childClone = cloneElement(child, {
			onChange: e => onChange(e),
		});
		const orientation = props.isVert ? <br /> : null;
		return (
			<Fragment>
				{childClone}
				{orientation}
			</Fragment>
		);
	});

	return (
		<StyleAuxiliary classes={props.className}>
			<FieldWrapper
				name={props.name}
				meta={meta}
				additionalProps={{
					labelPosition: labelPosition,
					...additionalProps,
				}}
				label={label || ''}
			>
				{children}
			</FieldWrapper>
		</StyleAuxiliary>
	);
};

RadioSet.propTypes = {
	className: PropTypes.string,
};

export default RadioSet;
